type DownloadDataProps = {
    file_name: string;
    file_size: string;
    file_type: string;
    direct_download: boolean;
    link?: string;
}
export const downloadData: DownloadDataProps[] = [
    {
        file_name: "College Brochure",
        file_size: "13.5 MB",
        file_type: "PDF",
        direct_download: false, //Files will not download directly but will require email submission
    },
    {
        file_name: "Career Guide",
        file_size: "2.33 MB",
        file_type: "PDF",
        direct_download: false, //Files will not download directly but will require email submission
    },
    {
        file_name: "Academic Calendar",
        file_size: "212 KB",
        file_type: "PDF",
        link: "/ACADEMIC_CALENDAR.pdf",
        direct_download: true, //Files will download directly without submitting an email
    },
    {
        file_name: "7th Convocation Brochure",
        file_size: "4.0 MB",
        file_type: "PDF",
        link: "/seventh_convocation_brochure.pdf",
        direct_download: true, //Files will download directly without submitting an email
    },
    // {
    //     file_name: "NARIM Course Structure",
    //     file_size: "161 KB",
    //     file_type: "PDF",
    //     direct_download: false, //Files will not download directly but will require email submission
    // },
    {
        file_name: "Acupuncture Course Structure",
        file_size: "177 KB",
        file_type: "PDF",
        direct_download: false, //Files will not download directly but will require email submission
    },
    {
        file_name: "Naturopathy Course Structure",
        file_size: "186 KB",
        file_type: "PDF",
        direct_download: false, //Files will not download directly but will require email submission
    },
    // {
    //     file_name: "Herbal Medicine Course Structure",
    //     file_size: "160 KB",
    //     file_type: "PDF",
    //     direct_download: false, //Files will not download directly but will require email submission
    // },
];